/* ⚛ REACT */
import { useEffect, useRef, useState } from "react";

/* 📦 LIBS */
import { useTranslation } from "react-i18next";

/* 🧩 COMPONENTS */
import { Button, Modal, Pagination, Filters, Label, Input, CustomLoading, Breadcrumb } from "../../../Components";

/* 🔗 SERVICE */
import { MaintenanceServices } from "../../../Services/maintenanceServices";

/* 🧠 REDUX */
import { store } from "../../../Redux/Store";
import { changeModal } from "../../../Redux/Actions";

/* 📁 ASSETS*/
import { Lupa } from "../../../Assets/icons";

/* 🎨 STYLES */
import { Container, CountContainer, LineTitle, TitleText, LineList, ListText, PageTitle, ContainerList, HeaderContainer, 
    InputContainer, FilterInput, ContainerHead, QuestionContainer, AllQuestions, ImageContainer, DatasContainer } from "./styles";

/* 🔧 UTILS */
import { isValidEndData, isValidStartData } from "../../../util/validate";

const options = [
    {id: 'equipaments', label: 'equipments'},
    {id: 'operators', label: 'operators'},
    {id: 'cities', label: 'cities'},
    // {id: 'procedures', label: 'Procedimentos'},
    {id: 'types', label: 'types'},
];

let OptionContent = {
    'operators': [],
    'equipaments': [],
    'cities': [],
    'procedures': [],
    'types': [
        {
            id: 1,
            title: 'Preventiva',
        },
        {
            id: 0,
            title: 'Corretiva',
        },
    ]
}

const ListMaintenance = () => {
    const { t } = useTranslation();

    document.title = t("maintenance.sub-items.list.document-title");

    const navigationFlow =  [
        { text: 'maintenance', page: null },
        { text: 'listing', page: null }
    ]

    const Services = useRef(new MaintenanceServices());
    
    const CompletList = useRef([]);
    const operatorsFilter = useRef([]);
    const equipamentsFilter = useRef([]);
    const citiesFilter = useRef([]);
    const proceduresFilter = useRef([]);
    const typesFilter = useRef([]);
    const searchFilter = useRef('');
    
    const [isLoading, setIsLoading] = useState(true);
    const [isLoadingOne, setIsLoadingOne] = useState(true);
    const [visible, setVisible] = useState(false);
    const [list, setList] = useState([]);
    const [maintenance, setMaintenance] = useState({});
    const [datainicio, setDatainicio] = useState('');
    const [datafim, setDatafim] = useState('');

    const getMaintenances = async() => {
        setIsLoading(true)
        let Itens = await Services.current.getAllMaintenance();
        CompletList.current = Itens
        setList(Itens)
        setIsLoading(false)
    }

    const getMaintenanceById = async(id) => {
        store.dispatch(changeModal('showmaintenance'))
        setIsLoadingOne(true)
        let currentMaintenance = await Services.current.getMaintenanceById(id);
        currentMaintenance.data = Object.values(currentMaintenance.data)
        currentMaintenance.data.sort((a, b) => a.Number - b.Number);
        currentMaintenance.data.push({
            question: 'Horário inicial da manutenção',
            ResponseType: 'text',
            id : 'dataInicio',
            Number: currentMaintenance.data.length + 1,
            value: currentMaintenance.dataInicio,
        })
        currentMaintenance.data.push({
            question: 'Horário final da manutenção',
            ResponseType: 'text',
            nextstep: 'finalQuestion',
            id : 'dataFim',
            Number: currentMaintenance.data.length + 2,
            value: currentMaintenance.dataFim,
        })
        setMaintenance(currentMaintenance)
        setIsLoadingOne(false)
    }

    const GetFilters = async() => {
        try {
            let equipments = await Services.current.getEquipments();
            OptionContent.equipaments = equipments
        } catch (error) {
            console.log(error)
        }

        try {
            let cities = await Services.current.getCities();
            cities.forEach(city => {
                city.id = city.codigo_ibge;
                delete city.codigo_ibge;
            })
            OptionContent.cities = cities
        } catch (error) {
            console.log(error)
        }

        try {
            let operators = await Services.current.getOperators();
            OptionContent.operators = operators
        } catch (error) {
            console.log(error)
        }

        try {
            // let procedures = await Services.current.getProcedures();
            OptionContent.procedures = []
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        getMaintenances();
        GetFilters();
    },[]);

    const Aplyfilter = async() => {
        setIsLoading(true)
        let Itens = await Services.current.getAllMaintenance(null, searchFilter.current, operatorsFilter.current, equipamentsFilter.current, 
            citiesFilter.current, proceduresFilter.current, typesFilter.current, formatData(datainicio), formatData(datafim));
        CompletList.current = Itens
        setList(Itens)
        setIsLoading(false)
    }

    const ChangeFilter = (type, option, value) => {
        if(value){
            if(type === 'operators'){
                operatorsFilter.current.push(option)
            }else if(type === 'equipaments'){
                equipamentsFilter.current.push(option)
            }else if(type === 'cities'){
                citiesFilter.current.push(option)
            }else if(type === 'procedures'){
                proceduresFilter.current.push(option)
            }else if(type === 'types'){
                typesFilter.current.push(option)
            }
        }else{
            if(type === 'operators'){
                let indexToRemove = operatorsFilter.current.indexOf(option);
                if (indexToRemove !== -1) {
                    operatorsFilter.current.splice(indexToRemove, 1);
                }
            }else if(type === 'equipaments'){
                let indexToRemove = equipamentsFilter.current.indexOf(option);
                if (indexToRemove !== -1) {
                    equipamentsFilter.current.splice(indexToRemove, 1);
                }
            }else if(type === 'cities'){
                let indexToRemove = citiesFilter.current.indexOf(option);
                if (indexToRemove !== -1) {
                    citiesFilter.current.splice(indexToRemove, 1);
                }
            }else if(type === 'procedures'){
                let indexToRemove = proceduresFilter.current.indexOf(option);
                if (indexToRemove !== -1) {
                    proceduresFilter.current.splice(indexToRemove, 1);
                }
            }else if(type === 'types'){
                let indexToRemove = typesFilter.current.indexOf(option);
                if (indexToRemove !== -1) {
                    typesFilter.current.splice(indexToRemove, 1);
                }
            }
        }
    }

    const changepage = async(page) => {
        setIsLoading(true);
        let Itens = await Services.current.getAllMaintenance(page, searchFilter.current, operatorsFilter.current, equipamentsFilter.current, 
            citiesFilter.current, proceduresFilter.current, typesFilter.current, formatData(datainicio), formatData(datafim));
        CompletList.current = Itens
        setList(Itens);
        setIsLoading(false);
    }

    const formatData = (data) => {
        if(!data) return '';
        data = new Date(data)
        let dia = (data.getDate()).toString();
        let mes = (data.getMonth() + 1).toString();
        let ano  = (data.getFullYear()).toString();
        mes = mes.length < 2 ? '0'+mes : mes;
        dia = dia.length < 2 ? '0'+dia : dia;
        data = [dia, mes, ano].join('/');
        return data.toString();
    }

    return(
        <>
            <Container>
                <Breadcrumb flow={navigationFlow}/>
                <PageTitle>
                    {t("maintenance.sub-items.list.page-title")}
                </PageTitle>

                <HeaderContainer>
                    <InputContainer>
                        <img src={Lupa} alt={t("inputs.search-maintenance.alt")}></img>
                        <FilterInput
                            onBlur={() => Aplyfilter()}
                            onKeyDown={(e) => {if(e.key === 'Enter'){Aplyfilter()}}}
                            onChange={(e) => searchFilter.current = e.target.value}
                            placeholder={t("inputs.search-maintenance.placeholder")}
                        />
                    </InputContainer>

                    <Button width={'fit-content'} text={visible ? t("buttons.apply") : t("buttons.filter")} color={'green'} disabled={false} onClick={() => {setVisible(!visible); Aplyfilter();}}></Button>
                    <Filters options={options} OptionContent={OptionContent} ChangeFilter={ChangeFilter} visible={visible}/>
                </HeaderContainer>

                <DatasContainer $visible={visible}>
                    <div>
                        <Label text={t("inputs.initial-date.label")} aling="flex-start"/>
                        <Input 
                            aling="flex-start"
                            id='datainicio' 
                            name='datainicio' 
                            type="datetime-local" 
                            placeholder={t("inputs.initial-date.placeholder")}
                            value={datainicio}
                            max={datafim}
                            invalidMessage={t("inputs.initial-date.invalid-message")}
                            validationFunction={(text) => isValidStartData(text, datafim)}
                            onchange={(text) => setDatainicio(text)}> 
                        </Input>
                    </div>
                    <div>
                        <Label text={t("inputs.final-date.label")} aling="flex-start"/>
                        <Input 
                            aling="flex-start"
                            id='datafim' 
                            name='datafim' 
                            type="datetime-local" 
                            placeholder={t("inputs.final-date.placeholder")}
                            value={datafim}
                            min={datainicio}
                            max={new Date(Date.now() - 3 * 60 * 60 * 1000).toISOString().slice(0, 16)}
                            invalidMessage={t("inputs.final-date.invalid-message")}
                            validationFunction={(text) => isValidEndData(datainicio, text)}
                            onchange={(text) => setDatafim(text)}> 
                        </Input>
                    </div>
                </DatasContainer>

                <ContainerHead>
                    <CountContainer>
                        {list?.total + " " + t("maintenance.sub-items.list.maintenances-number")} 
                    </CountContainer>
                </ContainerHead>

                <ContainerList>
                    <LineTitle>
                        {/* <TitleText>ID</TitleText> */}
                        <TitleText>{t("header-table.equipment")}</TitleText>
                        <TitleText>{t("header-table.responsible")}</TitleText>
                        <TitleText>{t("header-table.type")}</TitleText>
                    </LineTitle>

                    {isLoading?
                        <CustomLoading width={'150px'} height={'150px'}/>
                    :   
                        list?.data?.map((item, index) => (
                            <LineList key={index} onClick={() => getMaintenanceById(item.id)}>
                                {/* <ListText>{item.id}</ListText> */}
                                <ListText>{item.equipamento?.nome}</ListText>
                                <ListText>{item.nome}</ListText>
                                <ListText>{item.tipo}</ListText>
                            </LineList>
                        ))
                    }
                </ContainerList>
                <Pagination last_page={list?.last_page} currentpage={list?.current_page} changepage={changepage}/>
            </Container>
            
            <Modal title={t("modal.maintenance.title")} name={'showmaintenance'} width={'70%'} height={'90%'} >
                {isLoadingOne?
                    <CustomLoading width={'150px'} height={'150px'}/>
                :   
                    <AllQuestions>
                        {maintenance?.data?.map((item, index) => (
                            <QuestionContainer key={index}>
                                <Label text={item.question} />

                                {item.ResponseType === 'equipament' && <Label text={maintenance.equipamento.nome} />}

                                {(item.ResponseType === 'type_maintenance'|| item.ResponseType === 'select' || 
                                    item.ResponseType === 'number' || item.ResponseType === 'text') && 
                                    <Label text={item.value} />}
                                    
                                {item.ResponseType === 'image' &&
                                    <ImageContainer src={item.value} alt={item.question}/>
                                }
                            </QuestionContainer>
                        ))}
                    </AllQuestions>
                }
                
            </Modal>
        </>
    )
}

export default ListMaintenance;